import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@ui/atoms/Text';

import TagsGridContext from '../context';

// IP-15330: the tag name cell.
//
// Still an anchor pointing at /settings/tags/:id/edit even though a plain click
// opens the Brushaway instead of navigating: that keeps middle-click, copy-link
// and an existing bookmark working, and the edit route renders the listing with
// the drawer already open. Non-admins get plain text — they cannot edit, so a
// link into an editor would be a dead end.
function NameCell({ item }) {
  const { canEdit, onOpenTag } = useContext(TagsGridContext);

  if (!canEdit) {
    return <Text variant="body">{item.name}</Text>;
  }

  const handleClick = (event) => {
    // Let the browser handle the modified clicks that mean "open elsewhere".
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;

    event.preventDefault();
    onOpenTag(item.id);
  };

  return (
    // editPath is optional in the payload; without an href the anchor drops out
    // of the tab order, so keyboard users could not open the drawer at all.
    <Text variant="link" as="a" href={item.editPath || '#'} onClick={handleClick}>
      {item.name}
    </Text>
  );
}

NameCell.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    editPath: PropTypes.string
  }).isRequired
};

export default NameCell;
